const config = {
  API_URL_ONRENDER: "https://greenisland-api.onrender.com",
  // API_URL_ONRENDER: "http://localhost:3000",
};

export default config;
